import { ReactNode } from 'react';
import { ConfigProvider, App } from 'antd';
import ruRU from 'antd/locale/ru_RU';
import { lightTheme } from '@app/theme/antdTheme';

interface AntdThemeProviderProps {
  children: ReactNode;
}

export function AntdThemeProvider({ children }: AntdThemeProviderProps) {
  return (
    <ConfigProvider theme={lightTheme} locale={ruRU}>
      <App style={{ background: 'transparent', minHeight: '100%' }}>
        {children}
      </App>
    </ConfigProvider>
  );
}
